import {Directive, HostListener, Input, OnInit} from '@angular/core';
import {NgControl} from "@angular/forms";
import {CodeSettingsEnum} from "@amlCore/enums";

@Directive({
  selector: '[appAutoFillSetting]',
  standalone: true
})
export class AutoFillSettingDirective implements OnInit {

  /**
   * Тип код поля из настроек
   */
  private codeFormat: string;

  /**
   * Максимальное значение для каждого кода своё
   */
  private maxValue: number;
  private minValue = 1;

  /**
   * Получаем формат
   */
  @Input() set appAutoFillSetting(code: string) {
    this.codeFormat = code;
  }
  constructor(private control: NgControl) { }

  ngOnInit() {
    this.defineMaxValue();
  }

  @HostListener('input', ['$event'])
  onInput(event) {
    const value = event.target.value;
    if (value) {
      if (value > this.maxValue) {
        this.control.control.patchValue(this.maxValue);
      }
    } else {
        this.control.control.patchValue(this.minValue);
    }
  }

  private defineMaxValue() {
    switch (this.codeFormat) {
      case CodeSettingsEnum.ArchivingPeriod:
        this.maxValue = 3650;
        break;
      default:
        this.maxValue = 999;
    }
  }
}
